import React, { Component } from "react";
import { Provider } from 'react-redux';
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

//import './assets/css/quill.snow.css';
import './assets/css/material-dashboard-react.css';

import { connect } from 'react-redux';

import { Login } from "./views/Login";
import indexRoutes from "./routes/index.jsx";
import store, { makePersist } from './reducer/store';

const hist = createBrowserHistory();

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    }
  }

  componentWillMount() {
    makePersist(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
     return (
        <div>
          Loading...
        </div>
      );
    }

    return(
        <Router history={hist}>
          <Switch>
            { this.props.user === null ?
              <Route exact path="/" component={Login} /> :
              <Route exact path="/" component={Login} />
            }
            {this.props.user !== null ? indexRoutes.map((prop, key) => {
              return <Route path={prop.path} component={prop.component} key={key} />;
            }) : null}
            <Redirect from="*" to={this.props.user ? '/dashboard' : '/'} />
          </Switch>
        </Router>
    );
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = state => ({
  loggedIn: state.authReducer.loggedIn,
  user: state.authReducer.user,
})

const AppWithLoginState = connect(mapStateToProps, mapDispatchToProps)(App)

const WrappedApp = (
      <Provider store={store}>
        <AppWithLoginState />
      </Provider>
    );


ReactDOM.render(WrappedApp, document.getElementById("root"));
